import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero } from '../components/bits';
import { useLead } from '../components/LeadModal';
import { useContent } from '../lib/content';
import { CSR_STEPS, IMAGES } from '../content/data';

export default function CSR() {
  const { open } = useLead();
  const { ctList } = useContent();
  return (
    <div data-testid="csr-page">
    <SEO title="CSR Routing" description="Connect CSR commitments with programmes that create measurable capability and impact." />
      <PageHero
        ck="csr"
        tag="CSR Routing"
        lines={<>Make Your CSR Allocation Work Across <span className="font-serif italic font-normal text-electric">Multiple Outcomes.</span></>}
        intro="For eligible organisations, DITEC's model connects CSR commitments with programmes involving talent development, technology execution, research, digital communication, enterprise capability and institutional outcomes."
        image={IMAGES.leadership}
      >
        <ArrowBtn onClick={() => open('CSR Routing')} variant="primary" testId="csr-cta-discuss">Discuss CSR Routing</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap">
          <SectionTag>01 — The CSR Routing Process</SectionTag>
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {ctList('csr.steps', CSR_STEPS).map((s, i) => (
              <Reveal key={s.n} delay={i * 0.05} className={`rounded-3xl p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 ${i === 6 ? 'bg-navy text-white sm:col-span-2 lg:col-span-3 lg:flex lg:items-center lg:gap-10' : 'border border-navy/10 bg-white hover:shadow-xl hover:shadow-navy/10'}`}>
                <span className={`font-mono text-4xl font-semibold ${i === 6 ? 'text-gold/40' : 'text-electric/20'}`}>{s.n}</span>
                <div className={i === 6 ? '' : 'mt-4'}>
                  <h3 className="text-lg font-semibold tracking-tight">{s.title}</h3>
                  <p className={`mt-2 text-sm leading-relaxed ${i === 6 ? 'text-white/70' : 'text-navy/65'}`}>{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-10 max-w-3xl rounded-2xl border border-navy/10 bg-white p-6 text-sm leading-relaxed text-navy/65">
              Any financial examples shown on the public website are labelled as illustrative scenarios, not guaranteed returns.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-grid-dark bg-navy py-20 text-white sm:py-24">
        <div className="wrap flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
          <Reveal><h2 className="text-h2 max-w-xl font-semibold">Ready to structure your CSR around <span className="font-serif italic font-normal text-gold">measurable capability?</span></h2></Reveal>
          <Reveal delay={0.1}><ArrowBtn onClick={() => open('CSR Routing')} variant="gold" testId="csr-cta-bottom">Discuss CSR Routing</ArrowBtn></Reveal>
        </div>
      </section>
    </div>
  );
}
